import { createSlice } from '@reduxjs/toolkit'

export const municipalityFilterSlice = createSlice({
    name: 'municipalityFilter',
    initialState: {
        value: null,
    },
    reducers: {
        setMunicipalityFilter: (state, action) => {
            state.value = action.payload
        },
        resetMunicipalityFilter: (state) => {
            state.value = null
        }
    },
})

export const { setMunicipalityFilter, resetMunicipalityFilter } = municipalityFilterSlice.actions
export default municipalityFilterSlice.reducer